var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "url(#paint0_linear_1_423)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19545 9.6001L14.4755 16.6601L9.16211 22.4001H10.3579L15.0098 17.3746L18.7684 22.4001H22.8379L17.2608 14.943L22.2064 9.6001H21.0106L16.7264 14.2285L13.2649 9.6001H9.19545ZM10.954 10.481H12.8235L21.0791 21.5191H19.2095L10.954 10.481Z",
    fill: "url(#paint1_linear_1_423)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.954 10.481H12.8235L21.0791 21.5191H19.2095L10.954 10.481Z",
    fill: "url(#paint2_linear_1_423)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_423",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_423",
    x1: 9.16211,
    y1: 16.0001,
    x2: 22.8379,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_423",
    x1: 9.16211,
    y1: 16.0001,
    x2: 22.8379,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.ad66b6b3a4a2ba1be515f9c64166a5fa.svg";
export { ForwardRef as ReactComponent };